import saas from '@/utils/saas'
import Common from '@/utils/saas/common' // 工具类

// 卡类型
export const cardT = [
  { key: '00', label: '借记卡' },
  { key: '01', label: '贷记卡' },
  { key: '02', label: '准贷记卡' },
  { key: '03', label: '预付费卡' },
  { key: '04', label: '综合' }
]

// 个人查询银行卡列表
export function getCusList(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'person_bank_card_search', data, '查询银行卡列表')
}

// 企业查询银行卡列表
export function getCompList(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_bank_card_search', data, '查询银行卡列表')
}

// 个人查询银行卡添加
export function bankCardAdd(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'person_bank_card_add', data, '个人银行卡添加')
}

// 企业查询银行卡添加
export function bankCardAddBus(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_bank_card_add', data, '企业银行账户添加')
}

// 所属银行查询
export function getBankList(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'BANK_HEAD_QUERY', data, '所属银行查询')
}

// 所属支行查询
export function getBranchBankList(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'BANK_BRANCH_QUERY', data, '所属支行查询')
}

// 企业查询银行卡添加
export function initAddBus(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_info_search', data, '企业银行账户查询')
}
